export default __webpack_public_path__ + "static/media/icon-metamask.eb74783b.svg";